import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import useWindowResize from '../../hooks/useWindowResize';
import { ButtonStyled } from './ReadMore.styled';

type ReadMorePropsT = {
  text: string;
  maxCharacters?: number;
  rowsNumber?: number;
  onClick: () => void;
};

const ReadMore: React.FC<ReadMorePropsT> = ({
  text = '',
  maxCharacters = 150,
  rowsNumber = 0,
  onClick,
}) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const [charactersNumber, setCharactersNumber] = useState(maxCharacters);
  const [isDotsVisible, setIsDotsVisible] = useState(false);
  const [isControlsVisible, setIsControlsVisible] = useState(false);
  const [initialTextToShow, setInitialTextToShow] = useState('');

  const clearText = text?.replace(/(<([^>]+)>)/gi, '');

  const handleClickReadMore = () => {
    onClick();
  };

  const handleCountCharsInLine = () => {
    const charsInRowList: number[] = [];
    const words = clearText.split(' ') || [];
    const offscreenElement = document.createElement('div');
    let showCharactersLimit = 0;

    offscreenElement.classList.add('offscreen-element');
    document.body.appendChild(offscreenElement);

    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      offscreenElement.textContent += (i > 0 ? ' ' : '') + word;

      if (offscreenElement.scrollWidth > (ref?.current?.clientWidth as number)) {
        charsInRowList.push((offscreenElement?.textContent as string).length - word.length - 1);
        offscreenElement.textContent = '';
        offscreenElement.textContent = word;
      }
    }

    document.body.removeChild(offscreenElement);

    for (let j = 0; j < charsInRowList.length; j++) {
      if (j < rowsNumber) {
        showCharactersLimit += charsInRowList[j];
      }
    }

    setCharactersNumber(showCharactersLimit);
  };

  useWindowResize(() => {
    if (rowsNumber) {
      handleCountCharsInLine();
    }
  }, true);

  useEffect(() => {
    setIsControlsVisible(clearText.length > charactersNumber);
    setIsDotsVisible(clearText.length > charactersNumber);
    setInitialTextToShow(clearText.slice(0, charactersNumber));
  }, [charactersNumber, text]);

  const renderControl = () => {
    return (
      isControlsVisible && (
        <ButtonStyled onClick={handleClickReadMore}>
          <FormattedMessage id="common.readMore" defaultMessage="READ MORE" />
        </ButtonStyled>
      )
    );
  };

  return (
    <p ref={ref}>
      {initialTextToShow}
      {isDotsVisible && '...'} {renderControl()}
    </p>
  );
};

export default ReadMore;
